import React from 'react';
import {paths} from '../common/dictionaries/urls';
import WtsCatalogs from './components/catalogs/index';
import WtsEmployees from './components/employees/index';
import WtsCourses from './components/courses/index';
import WtsCourseForm from './components/courses/course';
import WtsCalendario from './components/calendarioCursos/index';
import WtsMonthlyActivities from './components/registroTrabajoAgencias';
import WtsEmployeesGestor from './components/employees/employeeGestor';


export const wtsRoutes = [
  {'component': <WtsCatalogs />, 'path': paths.WtsCatalogs},
  {'component': <WtsEmployees />, 'path': paths.WtsEmployees},
  {'component': <WtsCourses />, 'path': paths.WtsCourses},
  {'component': <WtsCourseForm />, 'path': paths.WtsCourseNew},
  {'component': <WtsCourseForm />, 'path': paths.WtsCourseEdit},
  {'component': <WtsCalendario />, 'path': paths.WtsCalendario},
  {'component': <WtsMonthlyActivities />, 'path': paths.WtsRegistroTrabajoAgencias},
  {'component': <WtsEmployeesGestor />, 'path': paths.WtsEmployeesGestor},
];
